import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Bell from './bell-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Bell {...validProps} />;
}

SvgComponent.iconName = 'bell';

export const BellIcon = svgIconWrapper(SvgComponent);
